import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParSucursalMatrizTiempos;
class Item extends React.PureComponent<{ value: Entity, onClick?: () => void }> {
    render() {
        return (
            this.props.onClick ?
                <kea.Link onClick={this.props.onClick} >
                    <span>
                        {this.props.value.NombreSucursalOrigen},{this.props.value.NombreSucursalDestino}
                    </span>
                </kea.Link> :
                <span>
                    {this.props.value.NombreSucursalOrigen}, {this.props.value.NombreSucursalDestino}{" "}
                </span>
        )
    }
}

/**Muestra la lista de sucursales faltantes en la matriz de distancias */
class ListaFaltantesNoRx extends React.PureComponent<{ value: Entity[], onClick?: (x: Entity) => void }, { busqueda: string }> {
    constructor(props) {
        super(props);
        this.state = { busqueda: "" };
    }
    render() {
        return (
            (this.props.value.length > 0) ?
                <div className="alert alert-warning" >
                    <kea.Text value={this.state.busqueda} onChange={x => this.setState({ busqueda: x })} placeholder="Búsqueda" />

                    <label>Matriz de tiempos incompleta, faltan {this.props.value.length} pares</label>
                    <br />
                    Los siguientes pares de sucursales faltan en la matriz de tiempos:
                    <br />
                    <h4>
                        <span>
                            {
                                this.props.value
                                    .filter(x => search(this.state.busqueda, x.NombreSucursalOrigen + " " + x.NombreSucursalDestino))
                                    .map(x => <Item value={x} onClick={this.props.onClick && (() => this.props.onClick!(x))} />)
                            }
                        </span>
                    </h4>
                </div> :
                <div className="alert alert-success">
                    <label>Todos los pares capturados</label>
                </div>
        )
    }
}

/**Muestra la lista de sucursales faltantes en la matriz de distancias */
export const ListaFaltantes = componentToRx(ListaFaltantesNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestiempos/list/faltan.tsx